module.exports = __webpack_public_path__ + "assets/img/main-logo-shijiazhuang.4152746b.png";